module.exports = __webpack_public_path__ + "static/media/cy-lab-barrer.8586c700.png";